var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canBeAddedToBasket
    ? _c("div", { staticClass: "cart-container" }, [
        _vm.showBuyButton
          ? _c("div", { staticClass: "checkout-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  attrs: { disabled: _vm.isLoading && !_vm.canBeAddedToBasket },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.addToBasket(true)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.multiLanguage.ProductBuyNow) +
                      "\n    "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "add-to-basket-container" }, [
          !_vm.allVariationsSelected || !_vm.isSalable
            ? _c(
                "button",
                {
                  directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                  staticClass:
                    "btn btn-block btn-primary btn-appearance disabled",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    title: _vm.tooltipText,
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip0_727_10530)" } },
                        [
                          _c("path", {
                            attrs: {
                              d: "M4.16808 11.666H15.1145C15.9585 11.666 16.3806 11.666 16.7165 11.5087C17.0125 11.37 17.2611 11.1475 17.4316 10.8686C17.6251 10.5521 17.6717 10.1327 17.7649 9.29383L18.2524 4.9063C18.2809 4.65008 18.2951 4.52197 18.2539 4.42282C18.2177 4.33573 18.153 4.26349 18.0705 4.21791C17.9765 4.16602 17.8476 4.16602 17.5898 4.16602H3.75142M1.66797 1.66602H2.70833C2.92885 1.66602 3.03911 1.66602 3.12538 1.70795C3.20132 1.74487 3.26425 1.80399 3.30583 1.87748C3.35307 1.96096 3.35995 2.07101 3.3737 2.2911L4.1289 14.3743C4.14266 14.5944 4.14953 14.7044 4.19677 14.7879C4.23836 14.8614 4.30129 14.9205 4.37723 14.9574C4.46349 14.9993 4.57375 14.9993 4.79427 14.9993H15.8346M6.2513 17.916H6.25964M13.7513 17.916H13.7596M6.66797 17.916C6.66797 18.1461 6.48142 18.3327 6.2513 18.3327C6.02118 18.3327 5.83464 18.1461 5.83464 17.916C5.83464 17.6859 6.02118 17.4993 6.2513 17.4993C6.48142 17.4993 6.66797 17.6859 6.66797 17.916ZM14.168 17.916C14.168 18.1461 13.9814 18.3327 13.7513 18.3327C13.5212 18.3327 13.3346 18.1461 13.3346 17.916C13.3346 17.6859 13.5212 17.4993 13.7513 17.4993C13.9814 17.4993 14.168 17.6859 14.168 17.916Z",
                              stroke: "white",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip0_727_10530" } }, [
                          _c("rect", {
                            attrs: { width: "20", height: "20", fill: "white" },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(
                    "\n\n      " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemAddToBasket")
                      ) +
                      "\n    "
                  ),
                ]
              )
            : !_vm.buttonLockState
            ? _c(
                "button",
                {
                  staticClass: "btn btn-block btn-primary btn-appearance",
                  attrs: { disabled: _vm.isLoading || !_vm.hasPrice },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.addToBasket()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip0_727_10530)" } },
                        [
                          _c("path", {
                            attrs: {
                              d: "M4.16808 11.666H15.1145C15.9585 11.666 16.3806 11.666 16.7165 11.5087C17.0125 11.37 17.2611 11.1475 17.4316 10.8686C17.6251 10.5521 17.6717 10.1327 17.7649 9.29383L18.2524 4.9063C18.2809 4.65008 18.2951 4.52197 18.2539 4.42282C18.2177 4.33573 18.153 4.26349 18.0705 4.21791C17.9765 4.16602 17.8476 4.16602 17.5898 4.16602H3.75142M1.66797 1.66602H2.70833C2.92885 1.66602 3.03911 1.66602 3.12538 1.70795C3.20132 1.74487 3.26425 1.80399 3.30583 1.87748C3.35307 1.96096 3.35995 2.07101 3.3737 2.2911L4.1289 14.3743C4.14266 14.5944 4.14953 14.7044 4.19677 14.7879C4.23836 14.8614 4.30129 14.9205 4.37723 14.9574C4.46349 14.9993 4.57375 14.9993 4.79427 14.9993H15.8346M6.2513 17.916H6.25964M13.7513 17.916H13.7596M6.66797 17.916C6.66797 18.1461 6.48142 18.3327 6.2513 18.3327C6.02118 18.3327 5.83464 18.1461 5.83464 17.916C5.83464 17.6859 6.02118 17.4993 6.2513 17.4993C6.48142 17.4993 6.66797 17.6859 6.66797 17.916ZM14.168 17.916C14.168 18.1461 13.9814 18.3327 13.7513 18.3327C13.5212 18.3327 13.3346 18.1461 13.3346 17.916C13.3346 17.6859 13.5212 17.4993 13.7513 17.4993C13.9814 17.4993 14.168 17.6859 14.168 17.916Z",
                              stroke: "white",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip0_727_10530" } }, [
                          _c("rect", {
                            attrs: { width: "20", height: "20", fill: "white" },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(
                    "\n\n      " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemAddToBasket")
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _c(
                "button",
                {
                  directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                  staticClass:
                    "btn btn-block btn-primary btn-appearance disabled",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    title: _vm._f("translate")(
                      "Ceres::Template.singleItemQuantityMax",
                      { max: _vm.maximumQuantity }
                    ),
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip0_727_10530)" } },
                        [
                          _c("path", {
                            attrs: {
                              d: "M4.16808 11.666H15.1145C15.9585 11.666 16.3806 11.666 16.7165 11.5087C17.0125 11.37 17.2611 11.1475 17.4316 10.8686C17.6251 10.5521 17.6717 10.1327 17.7649 9.29383L18.2524 4.9063C18.2809 4.65008 18.2951 4.52197 18.2539 4.42282C18.2177 4.33573 18.153 4.26349 18.0705 4.21791C17.9765 4.16602 17.8476 4.16602 17.5898 4.16602H3.75142M1.66797 1.66602H2.70833C2.92885 1.66602 3.03911 1.66602 3.12538 1.70795C3.20132 1.74487 3.26425 1.80399 3.30583 1.87748C3.35307 1.96096 3.35995 2.07101 3.3737 2.2911L4.1289 14.3743C4.14266 14.5944 4.14953 14.7044 4.19677 14.7879C4.23836 14.8614 4.30129 14.9205 4.37723 14.9574C4.46349 14.9993 4.57375 14.9993 4.79427 14.9993H15.8346M6.2513 17.916H6.25964M13.7513 17.916H13.7596M6.66797 17.916C6.66797 18.1461 6.48142 18.3327 6.2513 18.3327C6.02118 18.3327 5.83464 18.1461 5.83464 17.916C5.83464 17.6859 6.02118 17.4993 6.2513 17.4993C6.48142 17.4993 6.66797 17.6859 6.66797 17.916ZM14.168 17.916C14.168 18.1461 13.9814 18.3327 13.7513 18.3327C13.5212 18.3327 13.3346 18.1461 13.3346 17.916C13.3346 17.6859 13.5212 17.4993 13.7513 17.4993C13.9814 17.4993 14.168 17.6859 14.168 17.916Z",
                              stroke: "white",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip0_727_10530" } }, [
                          _c("rect", {
                            attrs: { width: "20", height: "20", fill: "white" },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(
                    "\n\n      " +
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemAddToBasket")
                      ) +
                      "\n    "
                  ),
                ]
              ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }